<template>
  <div style="height: 219px">
    <!-- デマンドヘッダー -->
    <TheDemandHeader
      v-if="sameStops"
      title="同じ場所は選択できません"
      page="1"
    />
    <TheDemandHeader
      v-else-if="selectedColumn == 'Departure'"
      title="出発地を選択してください"
      page="1"
    />
    <TheDemandHeader v-else title="到着地を選択してください" page="1" />

    <div v-if="busStops">
      <!-- 出発地選択UI -->
      <selectBusStop
        v-model:selectedBusStop="pickupStop"
        :busStops="busStops"
        label="出発地"
        :setBusStop="setBusStop"
        @click="onClickSelectBox('Departure')"
      />

      <!-- 目的地選択UI -->
      <selectBusStop
        v-model:selectedBusStop="dropoffStop"
        :busStops="busStops"
        label="目的地"
        :setBusStop="setBusStop"
        @click="onClickSelectBox('Destination')"
      />
    </div>

    <TheDemandActionButton1
      :pickupStop="pickupStop"
      :dropoffStop="dropoffStop"
      :isDisabled="isInputEmpty || sameStops"
    />
  </div>
</template>

<script>
import nativeHandlerService from "@/services/nativeHandler";
import storeJS from "@/store";
import { computed } from "vue";
import { useStore } from "vuex";

// ネイティブでバス停ピンを押下された際にバス停情報が渡ってくる
window.jcSetBusStop = function (BusStop) {
  if (storeJS.getters["demand/selectedColumn"] == "Departure") {
    var pickupStop = {};
    pickupStop.name = BusStop.name;
    pickupStop.id = BusStop.id;
    storeJS.commit("demand/setPickupBusStop", pickupStop);

    // 初回選択時のみ、出発地選択後に目的地選択に切り替える
    if (!storeJS.getters["demand/dropoffBusStop"].id) {
      changeColumn("Destination");
    }
  } else {
    var dropoffStop = {};
    dropoffStop.name = BusStop.name;
    dropoffStop.id = BusStop.id;
    storeJS.commit("demand/setDropoffBusStop", dropoffStop);
  }
};

// 出発地・目的地の入力欄をタップされた時の関数 Vue内とMapWebviewの指定値を同期させる
const changeColumn = (column) => {
  storeJS.commit("demand/setSelectedColumn", column);
  nativeHandlerService.demand.ncSetSelectColumn(column);
};

export default {
  name: "TemplateDemandBooking1",
  props: {
    busStops: {
      type: Array,
    },
  },
  setup(props) {
    const store = useStore();

    const pickupStop = computed({
      get() {
        return store.getters["demand/pickupBusStop"];
      },
      set(value) {
        store.commit("demand/setPickupBusStop", value);
      },
    });
    const dropoffStop = computed({
      get() {
        return store.getters["demand/dropoffBusStop"];
      },
      set(value) {
        store.commit("demand/setDropoffBusStop", value);
      },
    });

    const selectedColumn = computed(
      () => store.getters["demand/selectedColumn"]
    );

    // 子コンポーネントで選択した駅が変更するたびに発火
    const setBusStop = (busStop) => {
      // 開発ブラウザではネイティブの処理を仮想してWindow関数を叩く
      if (store.getters["common/device"] == "BROWSER") {
        window.jcSetBusStop(busStop);
      } else {
        // ネイティブへ情報を渡す
        nativeHandlerService.demand.ncSetBusStop(busStop);
      }
    };

    // バス停の変更なしでも、セレクトボックスタップでcolumn切り替え
    const onClickSelectBox = (column) => {
      changeColumn(column);
    };

    // 発着駅一方でも空ならdisable
    const isInputEmpty = computed(() => {
      if (!pickupStop.value.name || !dropoffStop.value.name) {
        return true;
      } else {
        return false;
      }
    });

    // 発着駅が同値ならdisable
    const sameStops = computed(() => {
      if (!pickupStop.value.id) {
        return false;
      } else if (pickupStop.value.id == dropoffStop.value.id) {
        return true;
      } else {
        return false;
      }
    });

    return {
      pickupStop,
      dropoffStop,
      setBusStop,
      onClickSelectBox,
      isInputEmpty,
      sameStops,
      selectedColumn,
    };
  },
};
</script>
